import React from "react";

export const TodoIcon = () => (
  <svg width="93" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="31"
      y="1"
      width="30"
      height="30"
      rx="15"
      fill="#D4403A"
      fillOpacity=".05"
      stroke="#D4403A"
      strokeWidth="2"
    />
    <path
      d="M52 11.213L50.787 10 46 14.787 41.213 10 40 11.213 44.787 16 40 20.787 41.213 22 46 17.213 50.787 22 52 20.787 47.213 16 52 11.213z"
      fill="#D4403A"
    />
  </svg>
);

export const DoneIcon = () => (
  <svg width="93" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="31"
      y="1"
      width="30"
      height="30"
      rx="15"
      fill="#0EAD0E"
      fillOpacity=".05"
      stroke="#0EAD0E"
      strokeWidth="2"
    />
    <path
      d="M42.717 20.258l-4.269-4.041L37 17.587 42.717 23 55 11.371 53.552 10 42.717 20.258z"
      fill="#0EAD0E"
    />
  </svg>
);

export const CloseIcon = ({ className = "", onClick = () => {} }) => (
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <g
      id="Desktop"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Desktop-|-Candidate-Search-results"
        transform="translate(-372.000000, -194.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g id="Group-3" transform="translate(120.000000, 180.000000)">
          <g id="ic-close-36px" transform="translate(252.000000, 14.000000)">
            <polygon
              id="Path"
              points="11.7272727 1.42909091 10.5709091 0.272727273 6 4.84363636 1.42909091 0.272727273 0.272727273 1.42909091 4.84363636 6 0.272727273 10.5709091 1.42909091 11.7272727 6 7.15636364 10.5709091 11.7272727 11.7272727 10.5709091 7.15636364 6"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const TabletIncompleteNotif = ({ className = "" }) => (
  <svg
    width="8"
    height="7"
    viewBox="0 0 8 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 7H8L4 0L0 7ZM4.36364 5.89474H3.63636V5.15789H4.36364V5.89474ZM4.36364 4.42105H3.63636V2.94737H4.36364V4.42105Z"
      fill="#D4403A"
    />
  </svg>
);

export const DownloadIcon = ({ className, onClick }) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M13.2857 8.47059V9.47059H14.2857H17.5654L10 16.947L2.43456 9.47059H5.71429H6.71429V8.47059V1H13.2857V8.47059ZM19 23H1V22.1765H19V23Z"
      stroke="#2196F3"
      strokeWidth="2"
    />
  </svg>
);

export const MagnifierIcon = ({ className = "" }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g
      id="Desktop"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Desktop-|-Candidate-Search-results"
        transform="translate(-129.000000, -192.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g id="Group-3" transform="translate(120.000000, 180.000000)">
          <g id="Group-2">
            <path
              d="M20.4351058,22.0628931 L19.707833,22.0628931 L19.4562607,21.8113208 C20.352773,20.7730132 20.89251,19.4236707 20.89251,17.946255 C20.89251,14.6620926 18.2304174,12 14.946255,12 C11.6620926,12 9,14.6620926 9,17.946255 C9,21.2304174 11.6620926,23.89251 14.946255,23.89251 C16.4236707,23.89251 17.7730132,23.352773 18.8113208,22.4608348 L19.0628931,22.7124071 L19.0628931,23.4351058 L23.6369354,28 L25,26.6369354 L20.4351058,22.0628931 Z M14.946255,22.0628931 C12.672956,22.0628931 10.8296169,20.219554 10.8296169,17.946255 C10.8296169,15.672956 12.672956,13.8296169 14.946255,13.8296169 C17.219554,13.8296169 19.0628931,15.672956 19.0628931,17.946255 C19.0628931,20.219554 17.219554,22.0628931 14.946255,22.0628931 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Users = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    stroke-linecap="round"
    strokeLinejoin="round"
    className="feather feather-users"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);
export const Home = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    stroke-linecap="round"
    strokeLinejoin="round"
    className="feather feather-home"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);
export const File = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    stroke-linecap="round"
    strokeLinejoin="round"
    className="feather feather-file-text"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);
export const Gear = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    stroke-linecap="round"
    strokeLinejoin="round"
    className="feather feather-settings"
  >
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </svg>
);

export const ReportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    stroke-linecap="round"
    strokeLinejoin="round"
    className="feather feather-bar-chart"
  >
    <line x1="12" y1="20" x2="12" y2="10"></line>
    <line x1="18" y1="20" x2="18" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="16"></line>
  </svg>
);

export const SettingsIcon = () => (
  <svg
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="32px"
    height="32px"
  >
    <path
      fill="none"
      stroke="#000000"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M16 12A4 4 0 1 0 16 20A4 4 0 1 0 16 12Z"
    />
    <path
      fill="none"
      stroke="#000000"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M25,16c0-0.677-0.081-1.335-0.223-1.97l2.615-2.298l-2-3.464l-3.304,1.118c-0.966-0.89-2.122-1.578-3.407-1.979L18,4h-4l-0.681,3.406c-1.286,0.401-2.441,1.089-3.407,1.979L6.608,8.268l-2,3.464l2.615,2.298C7.081,14.665,7,15.323,7,16s0.081,1.335,0.223,1.97l-2.615,2.298l2,3.464l3.304-1.118c0.966,0.89,2.122,1.578,3.407,1.979L14,28h4l0.681-3.406c1.286-0.401,2.441-1.089,3.407-1.979l3.304,1.118l2-3.464l-2.615-2.298C24.919,17.335,25,16.677,25,16z"
    />
  </svg>
);

export const WorkerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    stroke-linecap="round"
    strokeLinejoin="round"
    className="feather feather-users"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);
